import React from 'react';
import styles from './not-found.module.scss';

function NotFoundAdmin() {
  return (
    <div className={styles.notFoundWrapper}>
      <div className={styles.code404}>
        404 <span role="img" aria-label="lock">🔒</span>
      </div>
      <div className={styles.title}>
        Admin stranica nije pronađena
      </div>
      <div className={styles.message}>
        Ova admin stranica ne postoji ili nemate pristup.<br />Vratite se na admin kontrolnu tablu.
      </div>
      <a href="/admin/dashboard" className={styles.homeBtn}>Admin početna</a>
    </div>
  );
}

export default NotFoundAdmin; 